export default __webpack_public_path__ + "media/images/features/ja/ehime_minami-db9f9f94ba8a5686c43048cf15b2054e.png";